import React, { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import { Collapse } from 'antd';
import EmptyDetail from './EmptyDetail';

const Details = ({details, dlObject, statusImage, loading, endpoint}) => {

    const { Panel } = Collapse;
    const scrollRef = useRef(null);
    
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
      const ref = scrollRef;

      const handleScroll = (e) => {
          setScrolled(e.srcElement.scrollTop !== 0);
        }
    
        ref.current && ref.current.addEventListener('scroll', handleScroll)
    
        return () => {
          ref.current && ref.current.removeEventListener('scroll', handleScroll)
        }
    }, [])

    // Electron - settings endpoint for image
    const apiEndpoint = endpoint ? endpoint : '';
    
    return (
      <DetailsContainer>
      <DetailsHeader scrolled={scrolled}>
        <IconHolder>
          {details.thumbnail &&
            <img src={`${apiEndpoint}/${details.thumbnail}`} alt="file-icon" id="file-icon" />
          }
        </IconHolder>
        <FileName>
          <div className={`file-icon-small files-small-${dlObject.ObjectType}`} style={{ marginRight: '5px' }}></div>
          {statusImage && <img alt="thumbnail" src={`images/status/${statusImage}.png`} style={{ margin: '2px 5px -1px 0', float: 'left' }} />}
          <span>{dlObject.ObjectType ? dlObject.FileName + '.' + dlObject.ObjectType : dlObject.FileName}</span>
        </FileName>
      </DetailsHeader>
      <ScrollingContainer ref={scrollRef}>
        <DetailSection>
          <DetailItem>
            <DetailLabel>Status</DetailLabel>
            <DetailValue>{dlObject.Status}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Path</DetailLabel>
            <DetailValue>{dlObject.Path}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Size</DetailLabel>
            <DetailValue>{dlObject.FileSize}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Version</DetailLabel>
            <DetailValue>{dlObject.VersionID}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Description</DetailLabel>
            <DetailValue>{dlObject.Description}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Version Notes</DetailLabel>
            <DetailValue>{dlObject.KeyWords}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Created</DetailLabel>
            <DetailValue>{`${dlObject.CreateDate} ${dlObject.CreatedBy}`}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Last Accessed</DetailLabel>
            <DetailValue>{`${dlObject.LastAccessed} ${dlObject.LastAccessedBy}`}</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Last Updated</DetailLabel>
            <DetailValue>{`${dlObject.LastUpdated} ${dlObject.LastUpdatedBy}`}</DetailValue>
          </DetailItem>
        </DetailSection>
        <Collapse
          accordion={false}
          defaultActiveKey={['1']}
          bordered={true}
          style={{ margin: '0 -1px' }}
          items={[
            {
              key: '1',
              label: 'Profile',
              children: <>           
                          <ProfileName>{details.profileId}</ProfileName>
                          <DetailsProperties>
                            {details.properties.length > 0 ? (
                              details.properties.map((property, index) => (
                              <DetailItem key={index}>
                                <DetailLabel>{property.propertyID}</DetailLabel>
                                <DetailValue>{property.displayValue}</DetailValue>
                              </DetailItem>
                            ))
                            ) : (
                              <EmptyDetail loading={loading}>No Properties</EmptyDetail>
                            )}
                          </DetailsProperties>
                        </>,
            },
            {
              key: '2',
              label: 'Notes',
              children: <>           
                          <DetailsNotes>
                            {details.notes.length > 0 ? (
                              details.notes.map((note, index) => (
                                <Note key={index}>
                                  <div>{note.userID}</div>
                                  <div>{`${note.logDate} :: Version: ${note.versionID}`}</div>
                                  <div style={{ padding: '10px', color: '#333' }}>{`${note.message}`}</div>
                                </Note>
                              ))
                              ) : (
                                <EmptyDetail loading={loading}>No Notes</EmptyDetail>
                              )
                            }
                          </DetailsNotes>
                        </>,
            },
            {
              key: '3',
              label: 'Workflows',
              children: <>           
                          <DetailsWorkflows>
                            {details.workflows.length > 0 ? (
                              details.workflows.map((workflow, index) => (
                              <div key={index}>
                                <WorkflowRouteDetails>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Instance Name</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.instanceName}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Instance ID</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.instanceID}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Route Name</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.routeName}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Route Started</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.routeStarted}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Requested By</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.requestedBy}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Request Message</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.requestMessage}</DetailValue>
                                  </DetailItem>
                                </WorkflowRouteDetails>
                                <WorkflowStepDetails>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Task Name</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.stepName}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Task Type</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.stepType}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Task Started</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.stepStartDate}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Task Due Date</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.stepEndDate}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Step Instructions</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.stepInstructions}</DetailValue>
                                  </DetailItem>
                                  <DetailItem>
                                    <DetailLabel style={{ width: '100%' }}>Route Instructions</DetailLabel>
                                    <DetailValue style={{ width: '100%' }}>{workflow.routeInstructions}</DetailValue>
                                  </DetailItem>
                                </WorkflowStepDetails>
                              </div>
                            ))
                            ) : (
                              <EmptyDetail loading={loading}>No Workflows</EmptyDetail>
                            )}
                          </DetailsWorkflows>
                        </>,
            },
            {
              key: '4',
              label: 'Dependencies',
              children: <>           
                          <DependenciesContainer>
                            <DetailItem>
                              <DetailLabel style={{ float: 'left' }}>Primary Files</DetailLabel>
                              <DetailValue>
                                {details.dependencies.primary.length > 0 ? (
                                  details.dependencies.primary.map((file, index) => (
                                    <span key={index} style={{ display: 'inline-block' }}>{file.fileName}</span>
                                  ))
                                ) : (
                                  <EmptyDetail loading={loading}>No Primary Files</EmptyDetail>
                                )}
                              </DetailValue>
                            </DetailItem>
                            <DetailItem>
                              <DetailLabel style={{ float: 'left' }}>Child Files</DetailLabel>
                              <DetailValue>
                              {details.dependencies.children.length > 0 ? (
                                  details.dependencies.children.map((file, index) => (
                                    <span key={index} style={{ display: 'inline-block' }}>{file.fileName}</span>
                                  ))
                                ) : (
                                  <EmptyDetail loading={loading}>No Child Files</EmptyDetail>
                                )}
                              </DetailValue>
                            </DetailItem>
                            <DetailItem>
                              <DetailLabel style={{ float: 'left' }}>Projects</DetailLabel>
                              <DetailValue>
                                {details.dependencies.projects.length > 0 ? (
                                  details.dependencies.projects.map((project, index) => (
                                    <span key={index} style={{ display: 'inline-block', width: '100%' }}>{project.projectName}</span>
                                  ))
                                ) : (
                                  <EmptyDetail loading={loading}>No Projects</EmptyDetail>
                                )}
                              </DetailValue>
                            </DetailItem>
                          </DependenciesContainer>
                        </>,
            },
            {
              key: '5',
              label: 'Record Policy',
              children: <DetailsContainer>           
                          {details.recordPolicy.recordPolicyId ? (
                            <>
                              <DetailItem>
                                <DetailLabel>Policy ID</DetailLabel>
                                <DetailValue>{details.recordPolicy.recordPolicyId}</DetailValue>
                              </DetailItem>
                              <DetailItem>
                                <DetailLabel>Category</DetailLabel>
                                <DetailValue>{details.recordPolicy.recordCategory}</DetailValue>
                              </DetailItem>
                              <DetailItem>
                                <DetailLabel>Assigned Date</DetailLabel>
                                <DetailValue>{details.recordPolicy.recordAssignedDate}</DetailValue>
                              </DetailItem>
                              <DetailItem>
                                <DetailLabel>Action Date</DetailLabel>
                                <DetailValue>{details.recordPolicy.recordActionDate}</DetailValue>
                              </DetailItem>
                              <DetailItem>
                                <DetailLabel>Action Name</DetailLabel>
                                <DetailValue>{details.recordPolicy.recordPolicyAction}</DetailValue>
                              </DetailItem>
                              <DetailItem>
                                <DetailLabel>Status</DetailLabel>
                                <DetailValue>{details.recordPolicy.status}</DetailValue>
                              </DetailItem>
                            </>
                          ) : (
                              <EmptyDetail loading={loading}>No Record Policy</EmptyDetail>
                            )
                          }
                        </DetailsContainer>,
            },
            ]
          }
        />
      </ScrollingContainer>
      </DetailsContainer>
    )
}

const DetailsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  visibility: visible;
  .ant-collapse {
    border-radius: 0;
  }
`

const DetailItem = styled.div`
	width: 100%;
	margin: 2px 0;
	font-size: 12px;
  float: left;
`
const DetailLabel = styled.div`
	width: 50%;
  color: #888;
  float: left;
  padding-right: 5px;
	word-wrap: break-word;
	box-sizing: border-box;
`
const DetailValue = styled.div`
	width: 50%;
  color: #333;
  display: inline-block;
  word-wrap: break-word;
`
const DetailsHeader = styled.div`
  color: #333;
  padding: 20px 10px;
  overflow: hidden;
  flex: 0 0 auto;
  z-index: 2;
  box-shadow: ${p => p.scrolled ? '0px 4px 10px -4px rgba(0,0,0,0.48)' : 'none'};
`
const IconHolder = styled.div`
	width: 77px;
	height: 77px;
  float: left;
  position: relative;
  border: 1px solid #ccc;
  box-sizing: border-box;
  background: url("/images/small-loader.gif") transparent no-repeat center;
  img {
    width: 75px;
    height: 75px;
  }
`
const FileName = styled.div`
  padding: 0 15px;
	margin-top: 30px;
	width: 200px;
	cursor: default;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 12px;
	float: left;
  span {
    display: block;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
const ScrollingContainer = styled.div`
  height: 100%;
  margin-bottom: 90px;
  overflow-y: auto;
  flex: 1 1 auto;
  overflow-x: hidden;
`
const DetailSection = styled.div`
	margin-bottom: 10px;
	padding: 10px;
	overflow: hidden;
`
const ProfileName = styled.div`
  color: #333;
  font-size: 12px;
`
const DetailsProperties = styled.div`
  width: 100%;
  font-size: 12px;
  margin-top: 10px;
  display: inline-block;
`
const DetailsNotes = styled.div`
  display: inline-block;
  margin-bottom: -10px;
  width: 100%;
`
const DetailsWorkflows = styled.div`
  display: inline-block;
  margin-bottom: -10px;
  width: 100%;
`
const WorkflowRouteDetails = styled.div`
  display: inline-block;
  background: #ecedee;
  width: 100%;
`
const WorkflowStepDetails = styled.div`
  width: 100%;
  margin-left: 15px;
  margin-top: 10px;
  background: #f8f9f9;
  box-sizing: border-box;
`
const Note = styled.div`
  width: 100%;
  font-size: 12px;
  :not(:last-child) {
      border-bottom: 1px solid #dee0e3;
  }
  :not(:first-child) {
      margin-top: 10px;
  }
`

const DependenciesContainer = styled.div`
  display: inline-block;
`

export default Details;
